var _g, _path, _rect, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_5029_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.567383 19.3958C0.567383 8.77494 9.17729 0.165039 19.7981 0.165039H58.2597C68.8805 0.165039 77.4904 8.77495 77.4904 19.3958V57.8573C77.4904 68.4782 68.8805 77.0881 58.2597 77.0881H0.567383V19.3958Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.951998 19.3958C0.951998 8.98736 9.38971 0.549654 19.7981 0.549654H58.2597C68.6681 0.549654 77.1058 8.98736 77.1058 19.3958V57.8573C77.1058 68.2658 68.6681 76.7035 58.2597 76.7035H0.951998V19.3958Z",
    stroke: "white",
    strokeWidth: 0.769231
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 21,
    width: 34,
    height: 34,
    rx: 6,
    fill: "#06DDF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 45C42.866 45 46 41.866 46 38C46 34.134 42.866 31 39 31C35.134 31 32 34.134 32 38C32 41.866 35.134 45 39 45Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35V38L40.5 39.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5105 43.35L43.1605 47.18C43.1154 47.6787 42.885 48.1423 42.5147 48.4792C42.1444 48.8162 41.6611 49.002 41.1605 49H36.8305C36.3298 49.002 35.8466 48.8162 35.4763 48.4792C35.106 48.1423 34.8755 47.6787 34.8305 47.18L34.4805 43.35M34.4905 32.65L34.8405 28.82C34.8854 28.3231 35.1144 27.8609 35.4826 27.5242C35.8508 27.1874 36.3315 27.0005 36.8305 27H41.1805C41.6811 26.998 42.1644 27.1838 42.5347 27.5208C42.905 27.8578 43.1354 28.3214 43.1805 28.82L43.5305 32.65",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_5029_1996",
    x: -2.50954,
    y: 0.165039,
    width: 83.0767,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.07692,
    dy: 3.07692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5385
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5029_1996"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.07692,
    dy: 3.07692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5385
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_5029_1996",
    result: "effect2_innerShadow_5029_1996"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.a13cba1e91f0b0bd39dfcd8fcaec0fad.svg";
export { ForwardRef as ReactComponent };